export default __webpack_public_path__ + "static/sideLeft-aafc613a152fa37826ccba3c3e5af371.jpg";